module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zan-picker-column",
    class: _vm.classNames
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "zan-picker-column-wrapper",
    class: {
      dragging: _vm.isDragging
    },
    style: ({
      height: _vm.visibleContentHeight + 'px'
    })
  }, _vm._l((_vm.currentValues), function(item) {
    return _c('div', {
      staticClass: "zan-picker-column__item",
      class: {
        'zan-picker-column__item--selected': item === _vm.currentValue
      },
      style: ({
        height: _vm.itemHeight + 'px',
        lineHeight: _vm.itemHeight + 'px'
      })
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f7f8b71c!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/picker/src/picker-column.vue
// module id = 156
// module chunks = 0 2